import z from 'zod'

export const MARKETPLACE_STATUS_MAP = {
  IN_PREVIEW: '2',
  ACTIVE: '1',
  INACTIVE: '0',
} as const satisfies Record<string, MarketplaceStatus>

export const MarketplaceStatusSchema = z.union([
  z.literal('2'),
  z.literal('1'),
  z.literal('0'),
])

export const DURATION_UNIT_OPTIONS = [
  { label: 'Days', value: 'days' },
  { label: 'Weeks', value: 'weeks' },
  { label: 'Months', value: 'months' },
] as const

export type MarketplaceStatus = z.infer<typeof MarketplaceStatusSchema>
export const ITEM_TYPE_OPTIONS = {
  SERVICE: 1,
  PRODUCT: 2,
} as const
